import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionDireccionesComponent {
  idCliente
  agregando = false
  seleccionado = null
  promise = null

  constructor (FacturacionConfiguracionClientesDirecciones) {
    this.FacturacionConfiguracionClientesDirecciones = FacturacionConfiguracionClientesDirecciones
  }

  $onInit () {
    this.cargar()
  }

  cargar () {
    this.promise = this.FacturacionConfiguracionClientesDirecciones.get(this.idCliente)
      .then((({data}) => (this.data = data)))
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
  }

  refresh () {
    this.agregando = false
    this.seleccionado = null
    this.cargar()
  }

  seleccionar (item) {
    this.agregando = true
    this.seleccionado = item
  }

  cerrar () {
    this.agregando = false
    this.seleccionado = null
  }
}

module.component('clienteInformacionDirecciones', {
  controller: ClienteInformacionDireccionesComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/direcciones/component.js